import React from 'react';
import type { SpecifiedEventV2FormValues } from '../SpecifiedEventExclusionV2Modal';
import { SpecifiedEventExclusionV2Modal } from '../SpecifiedEventExclusionV2Modal';
import {
  formatEventExclusionsV2ForState,
  getDefaultEventExclusionV2Values,
} from '../../amendatory-coverages/line-items/SpecifiedEventExclusionV2';
import type {
  EventExclusionV2,
  RaterXCoverage,
} from '../../../../../../api/types/rater-x-preset';
import type { UpdateCoveragePayload } from '../../../../../../reducer';

const RaterXSpecifiedEventExclusionV2Modal = ({ data, close }: ModalProps) => {
  const onSubmit = (formValues: SpecifiedEventV2FormValues) => {
    const _exclusions = formatEventExclusionsV2ForState(formValues);

    data.setCoverage({
      id: data.coverageState.id,
      isSelected: true,
      value: {
        props: {
          exclusions: { values: _exclusions as unknown as EventExclusionV2[] },
        },
      },
    });
  };

  return (
    <SpecifiedEventExclusionV2Modal
      close={close}
      data={{
        onSubmit,
        exclusions: getDefaultEventExclusionV2Values(
          data.coverageState.value?.props?.exclusions
            ?.values as EventExclusionV2[]
        ),
      }}
    />
  );
};

type ModalProps = {
  data: {
    coverageState: RaterXCoverage;
    setCoverage: (payload: UpdateCoveragePayload) => void;
  };
  close: () => void;
};

export const RaterXSpecifiedEventExclusionV2ModalConfig = {
  RaterXSpecifiedEventExclusionV2Modal: {
    component: RaterXSpecifiedEventExclusionV2Modal,
    config: {
      title: 'Specified Event Exclusion Endorsement',
      fullWidth: true,
      maxWidth: 'md',
    },
  },
};
